export default {"src":"/_next/static/media/checkoutSM.3c8c5446.svg","height":162,"width":100,"blurWidth":0,"blurHeight":0};